<template>

    <div class="header">

        <a :href="'http://'+email"><h5 class="email">{{email}}</h5></a>
        <div class="invoice-logo">
            <div class="border-img">
                <div class="background-img">
                    <div class="older"></div>
                    <img :src="logo" alt="">

                </div>
            </div>
            <div class="name-company">
                <h1> {{companyName}} </h1>
            </div>
        </div>

    </div>

</template>


<script>

    export default {
        props: ["companyName", "logo","email"],
        mounted() {
        }
    }

</script>


<style scoped>
    .header{
        border-radius: 20px;
        padding-top: 60px;
        background-image: url("../../public/header-background.png");
        background-size: 100% ;
    }
    .email{
        padding-right: 50px;
        text-align: right;
    }
    a{
        text-decoration: none;
        color: #333333;
    }
    .invoice-logo {
        width: 100%;
        display: flex;
        justify-items: left;
        justify-content: left;
        align-items: center;
        padding-left:50px ;
        z-index: 1000;
    }

    .name-company{
        display: flex;
        justify-items: center;
        justify-content: center;
        align-items: center;
    }
    .border-img{
        z-index: 100;
        display: flex;
        justify-items: center;
        justify-content: center;
        align-items: center;
        align-content: center;
        width: 80px;
        border-radius: 50px;
        border: solid 2px #333333;
        height: 80px;
    }
    .invoice-logo img {
        width: 60px;
        height: 60px;
        z-index: 1000;
    }

    .background-img{
        width: 74px;
        height: 74px;

        background-color: #111111;

        border-radius: 50px;
        display: flex;
        justify-items: center;
        justify-content: center;
        padding-top: 8px;
    }

    .older{
        position: absolute;
        margin-top: -8px;
        width: 74px;
        height: 74px;
        border-radius: 50px;
        background-image:url("../../public/logo-background.png");
        background-repeat: no-repeat;
        z-index: 0;
        opacity: 0.2;
    }

    .name-company h1 {
        font-size: 35px;
        color: #222;
        letter-spacing: 8px;
        word-spacing: 5px;
        font-weight: bold;
        z-index: 1000;
        margin-left: 20px;

    }

    .line {
        z-index: 0;
        width: 35%;
        height: 3px;
        background-color: #333333;
    }
</style>